import { Reveal } from "@/components/Reveal";
import { GhostButton } from "@/components/Buttons";
import { scrollToId } from "@/lib/ui";

export default function DoNothing() {
  return (
    <section
      data-testid="do-nothing-section"
      className="border-y border-line/50 bg-[#030303] py-28 text-center lg:py-40"
    >
      <div className="mx-auto max-w-3xl px-4 sm:px-6">
        <Reveal>
          <div className="flex items-center justify-center gap-3 font-mono text-[11px] uppercase tracking-[0.3em] text-dim">
            <span className="pulse-dot h-1.5 w-1.5 rounded-full bg-neon" />
            P.E.E. OS Status
          </div>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="glow-text-neon mt-8 font-display text-6xl font-extrabold uppercase tracking-tight text-neon sm:text-8xl">
            Do nothing.
          </div>
        </Reveal>
        <Reveal delay={0.2}>
          <h2 className="mt-10 font-display text-2xl font-bold uppercase leading-snug tracking-tight text-white sm:text-3xl">
            Sometimes the best trade
            <br />
            is no trade.
          </h2>
        </Reveal>
        <Reveal delay={0.3}>
          <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-mist">
            Execution isn't about constantly being in the market. It is about
            acting when your process gives you a reason to act—and staying out
            when it doesn't.
          </p>
        </Reveal>
        <Reveal delay={0.4}>
          <GhostButton
            testid="do-nothing-cta"
            onClick={() => scrollToId("pricing")}
            className="mt-10"
          >
            Trade with a process
          </GhostButton>
        </Reveal>
      </div>
    </section>
  );
}
